module.exports = __webpack_public_path__ + "img/open_sided_and_attached_to_main_house_with_independent_roof.e24cf3b9.jpg";